/**
 * Разметка редактора постов в HTML для предпросмотра. Правила те же, что в мини-аппе
 * (kmk-tma, telegram-markdown.tsx) и в публикации в канал (kmk-api, toTelegramMarkdown):
 * сначала код, потом ссылки, голые адреса и цитаты, остальное последовательной заменой,
 * поэтому форматы вкладываются друг в друга. Любой текст пользователя экранируется до того,
 * как попасть в HTML.
 */

function escapeHtml(text: string): string {
	return text.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;")
}

function escapeHtmlAttr(text: string): string {
	return escapeHtml(text).replace(/"/g, "&quot;")
}

function applyInlineMarkup(text: string): string {
	return text
		.replace(/\*\*([\s\S]+?)\*\*/g, "<strong>$1</strong>")
		.replace(/__([\s\S]+?)__/g, "<em>$1</em>")
		.replace(/\+\+([\s\S]+?)\+\+/g, "<u>$1</u>")
		.replace(/~~([\s\S]+?)~~/g, "<del>$1</del>")
		.replace(/\|\|([\s\S]+?)\|\|/g, "<spoiler-span>$1</spoiler-span>")
}

/** В ссылках допустимы только http, https и tg:. */
export function sanitizeUrl(url: string): string | null {
	const trimmed = url.trim()
	if (!trimmed || /[\s"'<>]/.test(trimmed)) return null
	if (/^tg:/i.test(trimmed)) return trimmed

	try {
		const parsed = new URL(trimmed.startsWith("www.") ? `https://${trimmed}` : trimmed)
		return parsed.protocol === "http:" || parsed.protocol === "https:" ? parsed.href : null
	} catch {
		return null
	}
}

export function telegramMarkdownToHtml(text: string): string {
	const slots: string[] = []
	const hold = (html: string): string => {
		slots.push(html)
		return `\x00${slots.length - 1}\x00`
	}

	let result = text.replace(/```([\s\S]*?)```/g, (_match, code: string) =>
		hold(`<pre><code>${escapeHtml(code.replace(/^\n+|\n+$/g, ""))}</code></pre>`),
	)

	result = result.replace(/`(.+?)`/g, (_match, code: string) =>
		hold(`<code>${escapeHtml(code)}</code>`),
	)

	result = result.replace(/\[([^\]]+)\]\(([^)]+)\)/g, (_match, label: string, url: string) => {
		const safeUrl = sanitizeUrl(url)
		const content = applyInlineMarkup(escapeHtml(label))
		return hold(safeUrl ? `<a href="${escapeHtmlAttr(safeUrl)}">${content}</a>` : content)
	})

	result = result.replace(/(https?:\/\/[^\s<>"'\x00]+|www\.[^\s<>"'\x00]+)/g, (match) => {
		const safeUrl = sanitizeUrl(match)
		return hold(
			safeUrl
				? `<a href="${escapeHtmlAttr(safeUrl)}">${escapeHtml(match)}</a>`
				: escapeHtml(match),
		)
	})

	result = result.replace(/^(>+)(.*)$/gm, (_match, arrows: string, content: string) =>
		hold(
			`<blockquote data-level="${arrows.length}">${applyInlineMarkup(escapeHtml(content.trim()))}</blockquote>`,
		),
	)

	result = applyInlineMarkup(escapeHtml(result))

	while (result.includes("\x00")) {
		result = result.replace(/\x00(\d+)\x00/g, (_match, index: string) => slots[Number(index)] ?? "")
	}

	return result
}
